import { createApi } from "@reduxjs/toolkit/query/react";

import { axiosBaseQuery } from "@/api/base";
import { SnapshotCollection, SnapshotCollectionPermissionAccess } from "./snapshotCollection.types";

const TAG = "snapshotCollection";

export const snapshotCollectionApi = createApi({
  baseQuery: axiosBaseQuery({ baseUrl: "/pf-business-reports/snapshot-collections" }),
  reducerPath: "snapshotCollectionApi",
  tagTypes: [TAG],
  refetchOnFocus: true,
  endpoints: builder => ({
    createOrUpdateSnapshotCollection: builder.mutation<
      void,
      { id?: string; business_report_id?: string; name?: string }
    >({
      invalidatesTags: [TAG],
      query: ({ id, ...payload }) => ({
        url: id ? `/${id}` : "",
        method: id ? "PUT" : "POST",
        data: payload,
      }),
    }),
    deleteSnapshotCollectionPermission: builder.mutation<void, { id: string; permissionId: string }>({
      invalidatesTags: [TAG],
      query: ({ id, permissionId }) => ({
        url: `/${id}/permissions/${permissionId}`,
        method: "DELETE",
      }),
    }),
    createSnapshotCollectionPermission: builder.mutation<void, { id: string; role: string; users: string[] }>({
      invalidatesTags: [TAG],
      query: ({ id, role, users }) => ({
        url: `/${id}/permissions`,
        method: "POST",
        data: {
          permissions: users.map(user => ({ role, user_id: user, business_report_outcome_id: id })),
        },
      }),
    }),
    updateSnapshotCollectionAccess: builder.mutation<void, { id: string; access: SnapshotCollectionPermissionAccess }>({
      invalidatesTags: [TAG],
      query: ({ id, access }) => ({
        url: `/${id}/permissions/access`,
        method: "PATCH",
        data: { access },
      }),
    }),
    getSnapshotCollections: builder.query<SnapshotCollection[], { business_report_id: string } | void>({
      providesTags: [TAG],
      query: params => ({
        url: "",
        params,
      }),
    }),
  }),
});

export const {
  useGetSnapshotCollectionsQuery,
  useUpdateSnapshotCollectionAccessMutation,
  useCreateOrUpdateSnapshotCollectionMutation,
  useDeleteSnapshotCollectionPermissionMutation,
  useCreateSnapshotCollectionPermissionMutation,
} = snapshotCollectionApi;
